export default __webpack_public_path__ + "static/media/our-services-home-care-reablement-services-01.d6cad2c7.jpg";